import deepmerge from "deepmerge";
import { getFontOverlay } from "webapp/lib/theme/font-overlays/get-font-overlay";

const themeCache = new Map();

export function clearThemeCache() {
    themeCache.clear();
}

function normalizeTheme(root: any, lookupSource?: any, theme?: any) {
    if (theme === undefined) {
        theme = deepmerge(root, {});
        theme.fontStyles = getFontOverlay(theme.fontTheme);
        lookupSource = theme;
    }

    let finished = false;
    while (!finished) {
        let skipped = false;
        // eslint-disable-next-line guard-for-in
        for (const key in theme) {
            const val = theme[key];
            try {
                if (typeof val === "string" && val.startsWith("_")) {
                    const lookupKey = val.substr(1, val.length - 1);

                    const split = lookupKey.split(".");
                    let newValue = lookupSource;
                    for (const s of split) {
                        newValue = newValue[s];
                    }

                    if (typeof newValue === "string" && newValue.startsWith("_")) {
                        skipped = true;
                        continue;
                    }
                    theme[key] = newValue;
                } else if (typeof theme[key] === "object") {
                    normalizeTheme(root, lookupSource, theme[key]);
                }
            } catch {
                // do nothing we just wont normalize the failed value
            }
        }

        finished = !skipped;
    }

    return theme;
}

export function mergeTheme<TBase extends {}, TOverlay extends { overlayName: string }>(
    baseTheme: TBase,
    overlays: (TOverlay | undefined)[]
): TBase {
    const themeName: string | undefined = (baseTheme as any).overlayName;
    const realOverlays: TOverlay[] = overlays.filter(o => o !== undefined) as TOverlay[];

    if (realOverlays.length === 0) return normalizeTheme(baseTheme);

    const overlayPartialKey = realOverlays
        .map(o => o.overlayName)
        .filter(n => n !== undefined)
        .reduce((pv, cv) => pv + cv);

    const fullName = themeName + overlayPartialKey;

    // See if normalizedTheme has been cached
    const cachedTheme = themeCache.get(fullName);
    if (cachedTheme !== undefined) {
        return cachedTheme;
    }

    // OVERLAY ORDER IS IMPORTANT
    const result = normalizeTheme(
        deepmerge.all([baseTheme, ...realOverlays], {
            arrayMerge: (_, src) => src,
        })
    ) as TBase;

    (result as any).overlayName = fullName;
    themeCache.set(fullName, result);

    return result;
}
